/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState, useRef } from "react";
import { ScrollView, TouchableOpacity, View } from "react-native";
import { useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";

import { SearchBar, Text } from "UpduoLibrary";
import {
  skaleSecondaryBlue,
  skaleBlack,
  skaleWhite,
  skaleDeactiveGray,
  skaleWebTextLightGray,
  upduoLighterGray,
} from "config/UpduoColors";
import { GET_STAFF_MEMBER_USER_SEARCH_LIST } from "graphql/internal/Queries";
import { getNodes } from "config/Utilities";

export default function UserSearchBar() {
  const history = useHistory();

  const [entries, setEntries] = useState<any[]>([]);

  const [selectedOption, setSelectedOption] = useState("");
  const selectedOptionRef = useRef("");
  selectedOptionRef.current = selectedOption;

  const searchBarWidth = 250;

  const [getStaffMemberUserSearchList, {}] = useLazyQuery(
    GET_STAFF_MEMBER_USER_SEARCH_LIST,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
      onCompleted: ({ staffUsers }) => {
        setEntries(getNodes(staffUsers));
      },
    }
  );

  const _handleSearch = (searchString: string) => {
    if (searchString.length >= 3) {
      getStaffMemberUserSearchList({
        variables: {
          cursor: null,
          getStaffMemberUserListRequest: {
            searchString,
          },
        },
      });
    } else {
      setEntries([]);
    }
  };

  const _handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (entries.length > 0) {
        setSelectedOption(entries[0].id);
        history.push(`/dashboard/user/${entries[0].id}`);
      }
    }
  };

  return (
    <View style={{ width: searchBarWidth, marginLeft: 20 }}>
      <SearchBar
        placeholder={"Search Users"}
        placeholderTextColor={upduoLighterGray}
        onChangeText={(searchString) => {
          _handleSearch(searchString);
        }}
        onFocus={({ nativeEvent }) => {
          _handleSearch(nativeEvent.text);
        }}
        onBlur={() => {
          setTimeout(() => {
            if (!selectedOptionRef.current) {
              setEntries([]);
            }
          }, 200);
        }}
        onKeyPress={(e) => _handleKeyPress(e)}
      />
      {entries.length > 0 ? (
        <View
          style={{
            width: searchBarWidth,
            position: "absolute",
            top: 28,
            backgroundColor: skaleWhite,
            borderLeftWidth: 2,
            borderRightWidth: 2,
            borderBottomWidth: 2,
            borderColor: skaleSecondaryBlue,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
          }}
        >
          <View
            style={{
              alignSelf: "center",
              width: "97%",
              height: 1,
              backgroundColor: skaleDeactiveGray,
              marginLeft: "3%",
              marginTop: 5,
            }}
          />
          <ScrollView style={{ maxHeight: 300, paddingTop: 5 }}>
            {entries.map((item) => (
              <View style={{ paddingBottom: 10, paddingHorizontal: 10 }}>
                <TouchableOpacity
                  onPress={() => {
                    setSelectedOption(item.id);
                    setTimeout(() => {
                      history.push(`/dashboard/user/${item.id}`);
                    }, 100);
                  }}
                  key={item.id}
                >
                  <Text
                    style={{ fontSize: 16, color: skaleBlack }}
                  >{`${item.firstName} ${item.lastName}`}</Text>
                  <Text style={{ fontSize: 10, color: skaleWebTextLightGray }}>
                    {item.primaryEmail}
                  </Text>
                </TouchableOpacity>
              </View>
            ))}
          </ScrollView>
        </View>
      ) : null}
    </View>
  );
}
